import {observer} from 'mobx-react';
import Subnav from '../../Subnav';
import {Panel, Layout} from 'shared/components';
import {InteractiveTable} from 'main/components';
import {withState, t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {PerformanceReviewReviewee, PerformanceReviewReview} from 'main/stores/performance_reviews';
import ShareWithRevieweeModal from 'main/containers/performance_reviews/components/reviews/components/view/components/ShareWithRevieweeModal';
import {TeamContainerState} from '../state';
import {getMyTeamColumns, MY_REVIEWS_COLUMNS} from './columns';
import useModal from 'shared/hooks/useModal';
import UnshareRevieweeModal from 'main/containers/performance_reviews/components/reviews/components/view/components/UnshareRevieweeModal';

const TeamContainer = observer(({ uiState}) => {
  const shareWithRevieweeModalOpen = useModal(uiState, 'ShareWithRevieweeModal', 'selectedReviewee');
  const unshareRevieweeModalOpen = useModal(uiState, 'UnshareRevieweeModal', 'selectedReviewee');
  const {cycle, match, scope, selectedReviewee} = uiState;

  return (
    <div>
      <Subnav title={cycle.name} match={match} scope={scope}/>
      <Layout>
        <Panel.Stack loose>
          {scope.team && <InteractiveTable
            title={t('performance_reviews.view.My Team')}
            columns={getMyTeamColumns(cycle)}
            uiState={uiState}
            onMount={agent => uiState.setInteractiveAgent(agent)}
            showPath={(model) => uiState.writePathForReviewee(model)}
            customLinks={model => uiState.customLinksFor(model)}
            onlyShowCustomLinks
            proxy={{
              type: 'async',
              modelType: types.PERFORMANCE_REVIEWS.REVIEWEE,
              model: PerformanceReviewReviewee,
              endpoint: endpoints.PERFORMANCE_REVIEWS.REVIEWEES.TEAM.with(match.params.cycleId)
            }}
          />}
          <InteractiveTable
            title={t('performance_reviews.view.My Self and Peer Reviews')}
            showLinks={false}
            columns={MY_REVIEWS_COLUMNS}
            uiState={uiState}
            showPath={(model) => uiState.writePathForReviewee(model.reviewee)}
            proxy={{
              type: 'async',
              modelType: types.PERFORMANCE_REVIEWS.REVIEW,
              model: PerformanceReviewReview,
              endpoint: endpoints.PERFORMANCE_REVIEWS.REVIEWS.NON_MANAGER.with(match.params.cycleId)
            }}
          />
        </Panel.Stack>
      </Layout>
      <ShareWithRevieweeModal
        reviewee={selectedReviewee}
        isOpen={shareWithRevieweeModalOpen}
        onClose={() => uiState.closeShareWithRevieweeModal()}
        onSubmit={() => uiState.shareReview()}
      />
      <UnshareRevieweeModal
        reviewee={selectedReviewee}
        isOpen={unshareRevieweeModalOpen}
        onClose={() => uiState.closeUnshareRevieweeModal()}
        onSubmit={() => uiState.unshareReview()}
      />
    </div>
  );
});

export default withState(TeamContainer, TeamContainerState);
